(function Module() {
	'use strict';

	mySynch.factory('BenchmarkingReportService', [
		'$http',
		'ApiBase',
		function benchmarkingReportService($http, apiBase) {
			return {
				getBenchmarkingReportData: function getBenchmarkingReportData(filters, performanceContext, callback) {
					$http.put(apiBase.prepareUrl('/data/benchmark-report'),filters, _.assign(apiBase.sendHeaders(performanceContext),{timeout: 300000})).then(
						function success(response) {
							apiBase.processHeaders(response.headers);
							var data = apiBase.lowerCaseObjectKeys(response.data);
							apiBase.callbackOrLog(callback, null, data || null);
						},
						function failure(response) {
							var data = {
								statusCode: response.status,
								statusText: response.statusText
							};
							apiBase.callbackOrLog(callback, response.data || 'unspecified', data);
						});
				},
				getBenchmarkingReportFilterOptionsData: function getBenchmarkingReportFilterOptionsData(performanceContext, callback) {
					$http.get(apiBase.prepareUrl('/data/benchmark-report/filter-options'), apiBase.sendHeaders(performanceContext)).then(
						function success(response) {
							apiBase.processHeaders(response.headers);
							var data = _.get(response,"data");							
							apiBase.callbackOrLog(callback, null, data || null);
						},
						function failure(response) {
							var data = {
								statusCode: response.status,
								statusText: response.statusText
							};
							apiBase.callbackOrLog(callback, response.data || 'unspecified', data);
						});
				}
			};
		}
	]);
})();
